/**
 * @context:
 * - 2025.11.17 오후 12시 이후부터 2025 겨울 브랜드 캠페인 시작 ~ 아마 내년 중순?
 * - 포인트 프로모션 노출기간: 11/17 오후 2시 ~ 11/30 자정 (2주)
 * @link:
 * - slack: https://healingpaper.slack.com/archives/C06F94P7MAM/p1762328340338569?thread_ts=1762241834.295359&cid=C06F94P7MAM
 * - notion: https://www.notion.so/healingpaper/2a1d9338d3d48058bfddde3ef5272582?source=copy_link
 */

// production
export const WINTER_BRAND_CAMPAIGN_2025_START_TIME = '2025-11-17 12:00'
export const WINTER_BRAND_CAMPAIGN_PROMOTION_START_TIME = '2025-11-17 14:00'
export const WINTER_BRAND_CAMPAIGN_PROMOTION_END_TIME = '2025-12-01 00:00'

// staging (2시간 일찍)
export const STAGING_WINTER_BRAND_CAMPAIGN_2025_START_TIME = '2025-11-16 21:40'
export const STAGING_WINTER_BRAND_CAMPAIGN_PROMOTION_START_TIME = '2025-11-16 21:45'
export const STAGING_WINTER_BRAND_CAMPAIGN_PROMOTION_END_TIME = '2025-11-30 22:00'
